/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AppServices_Sandbox_SandboxConfigDto } from '../models/Wealthlane_AppServices_Sandbox_SandboxConfigDto';
import type { Wealthlane_Shared_Hosting_Dtos_SandboxConfiguration_SandboxConfigurationDto } from '../models/Wealthlane_Shared_Hosting_Dtos_SandboxConfiguration_SandboxConfigurationDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SandboxConfigurationService {

    /**
     * @param companyId
     * @returns Wealthlane_Shared_Hosting_Dtos_SandboxConfiguration_SandboxConfigurationDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiSandboxConfiguration(
        companyId: string,
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_SandboxConfiguration_SandboxConfigurationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/sandbox/configuration/{companyId}',
            path: {
                'companyId': companyId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static postApiIdentityApiSandboxConfiguration(
        requestBody?: Wealthlane_AppServices_Sandbox_SandboxConfigDto,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/api/sandbox/configuration',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
